import React from 'react';
import { Trash } from 'react-bootstrap-icons';
import { withTranslation, WithTranslation } from 'react-i18next';
import Location from '../../../../Model/models/locationModel';
import Order from '../../../../Model/models/orderModel';
import Shipping from '../../../../Model/models/shippingModel';
import ProductType from '../../../../Model/productType';
import OrderFormShippingModal from './orderFormShippingModal';

interface OrderFormShippingsProps extends WithTranslation {
  order: Order,
  productTypes: ProductType[],
  onChange: (order: Order) => void
}

interface OrderFormShippingsState {
  order: Order,
  showShippingModal: boolean
}

class OrderFormShippings extends React.Component<OrderFormShippingsProps, OrderFormShippingsState> {

  constructor(props: OrderFormShippingsProps) {
    super(props);
    this.state = {
      order: props.order || new Order(),
      showShippingModal: false
    };
  }

  shouldComponentUpdate(nextProps: OrderFormShippingsProps) {
    if (nextProps.order !== this.state.order) {
      this.setState({ order: nextProps.order });
    }
    return true;
  }

  getShippingGroupByLocation() {
    const shippingsGroups: { location: Location, shippings: Shipping[] }[] = [];
    for (let shipping of this.state.order.shippings) {
      let group = shippingsGroups.find(sg => sg.location.id === shipping.location.id);
      if (!group) {
        group = { location: shipping.location, shippings: [] };
        shippingsGroups.push(group);
      }
      group.shippings.push(shipping);
    }
    return shippingsGroups;
  }

  getFriendlyName(productTypeId: number) {
    return this.props.productTypes.find(pt => pt.id === productTypeId)?.friendly_name;
  }

  addShipping() {
    // this.state.shippings.push({ items: [], showModal: true });
    this.setState({ showShippingModal: true });
  }

  onSaveShippings = (shippings: Shipping[]) => {
    for (let shipping of shippings) {
      const shippingWithSameLocation = this.state.order.shippings.find(s => {
        return s.sensors_type_id === shipping.sensors_type_id &&
          (
            s.location_id === shipping.location_id ||
            (s.location.id === shipping.location.id) ||
            (JSON.stringify(s.location) === JSON.stringify(shipping.location))
          );
      });
      if (shippingWithSameLocation) {
        shippingWithSameLocation.quantity += shipping.quantity;
      } else {
        this.state.order.shippings.push(shipping);
      }
    }
    this.props.onChange(this.state.order);
    this.setState({
      showShippingModal: false,
      order: this.state.order
    });
  };

  deleteShippingGroup(group: { location: Location, shippings: Shipping[] }) {
    for (const shipping of group.shippings) {
      const index = this.state.order.shippings.findIndex(s => s.id === shipping.id);
      this.state.order.shippings.splice(index, 1);
    }
    this.setState({ order: this.state.order });
  }

  render() {
    const groups = this.getShippingGroupByLocation();
    return <div className='fullTable shadow rounded'>
      <table className='orderTable fixed-table' style={{ minHeight: 'auto' }}>
        <thead className='tableTop'>
          <tr>
            <th scope='col'>{this.props.t('SHIPPING_NAME')}</th>
            <th scope='col'>{this.props.t('SHIPPING_ADDRESS')}</th>
            {/* <th scope='col'>{this.props.t('SHIPPING_CONTACTS')}</th> */}
            <th scope='col'>{this.props.t('ITEM')}</th>
            <th scope='col'>{this.props.t('QUANTITY')}</th>
            <th scope='col' className='btn-cell-add'>
              <div className='addButtonWrapper'>
                <button className='addButton' onClick={() => this.addShipping()}>
                  {this.props.t('ADD')}
                </button>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <div className="d-inline position-absolute scrollbar-td">
            {/* SCROLL BAR SPACE */}
          </div>
          {
            groups.map((group, index) => <>
              <tr key={`shipping-${index}`}>
                <td>
                  {group.location.contact?.name} {group.location.contact?.surname}<br />
                  {group.location.contact?.mail}<br />
                  {group.location.contact?.phone}<br />
                </td>
                <td>
                  {group.location?.address && <>{group.location?.address}<br /></>}
                  {group.location?.city && <>{group.location?.city}<br /></>}
                  {
                    (group.location?.province || group.location?.postcode) &&
                    <>{group.location?.province} {group.location?.postcode}<br /></>
                  }
                  {group.location?.country && <>{group.location?.country}<br /><br /></>}
                </td>
                <td className='bottomLine font-weight-bold'>
                  {group.shippings.map((item: Shipping, i: number) => <div
                    key={`shipping-item-${index}-${i}type`}
                  >
                    {this.getFriendlyName(item.sensors_type_id as number)}
                  </div>)}
                </td>
                <td className='bottomLine font-weight-bold'>
                  {group.shippings.map((item: Shipping, i: number) => <div
                    key={`shipping-item-${index}-${i}qta`}
                  >
                    x{item.quantity}
                  </div>)}
                </td>
                <td className="d-flex">
                  <button
                    className="closeButton my-2"
                    style={{ marginRight: '0.25em' }}
                    onClick={() => this.deleteShippingGroup(group)}
                  >
                    <Trash />
                  </button>
                </td>
              </tr>
            </>)
          }
          {
            groups.length === 0 &&
            <tr>
              <td className="text-center" colSpan={5}>{this.props.t('NO_RESULTS')}</td>
            </tr>
          }
        </tbody>
      </table>
      <OrderFormShippingModal
        order={this.state.order}
        productTypes={this.props.productTypes}
        shippings={this.state.order.shippings}
        showModal={this.state.showShippingModal}
        onClose={() => { this.setState({ showShippingModal: false }); }}
        onSave={this.onSaveShippings}
      />

    </div>;
  }

}

export default withTranslation()(OrderFormShippings);